/** @jsx jsx */
import { css, jsx } from '@emotion/core';
import React from 'react';

import { useT } from 'client/i18n/hooks/useT';
import Heading from '../../shared/Heading';
import Text from '../../shared/Text';
import { PodcastImage, SwitchToAnchor } from './styles';

type Props = {
  imageSrc: string;
  authorName: string;
};

export const SwitchToAnchorHero = ({ imageSrc, authorName }: Props) => {
  const t = useT();
  return (
    <SwitchToAnchor>
      <Heading size="md" color="#5000b9" align="center" isBold={true}>
        {t(
          'ImportOnboarding.SwitchToAnchorHero.Header',
          'Switch your podcast to Anchor',
          'Switch podcast to Anchor header'
        )}
      </Heading>
      <div
        css={css`
          margin: 20px 0 40px;
        `}
      >
        <Text align="center" size="lg">
          {t(
            'ImportOnboarding.SwitchToAnchorHero.Features',
            'Free hosting, automatic distribution, easy monetization.',
            'Benefits of switching to Anchor message'
          )}
        </Text>
      </div>
      <PodcastImage src={imageSrc} />
      <Text align="center" size="md" isBold={true}>
        {t(
          'ImportOnboarding.SwitchToAnchorHero.PodcastAuthor',
          'by {authorName}',
          'Podcast author',
          { authorName }
        )}
      </Text>
    </SwitchToAnchor>
  );
};
